// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"04fc5f4c","455":"d54e0528","977":"d2a059f6"}[chunkId] + ".chunk.js";
};